import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=45776ff5&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3194833414/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45776ff5')) {
      api.createRecord('45776ff5', component.options)
    } else {
      api.reload('45776ff5', component.options)
    }
    module.hot.accept("./Collection.vue?vue&type=template&id=45776ff5&", function () {
      api.rerender('45776ff5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Collection.vue"
export default component.exports